import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary members-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, "Employer Actions", -1)
const _hoisted_3 = { class: "d-flex flex-column align-items-start gap-20 w-100" }
const _hoisted_4 = { class: "d-flex align-items-center gap-10 w-100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-search w-5" }, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center gap-10 w-100" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-calendar w-5" }, null, -1)
const _hoisted_8 = { class: "d-flex align-items-center gap-10 w-100 plan-modal" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-Hand-Pills fs-lg w-5" }, null, -1)
const _hoisted_10 = { class: "d-flex align-items-center gap-10 w-100" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-note fs-lg w-5" }, null, -1)
const _hoisted_12 = { class: "d-flex align-items-center gap-10 w-100" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-note fs-lg w-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_router_link, {
          class: "fs-sm",
          to: { name: 'local.contract-information' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Summarized Contract Info ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_router_link, {
          class: "fs-sm",
          to: { name: 'user.demographic' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Missing Demographic Info ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_router_link, {
          class: "fs-sm",
          to: { name: 'employer.productions.list' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" List of Productions ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal('employer-e-remittance-report', 'Submit eRemittance Report', null)), ["prevent"])),
          class: "plan-modal fs-sm"
        }, " Submit eRemittance Report ")
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openModal('employer-aca-report', 'Employee Health Coverage Information Request', null)), ["prevent"])),
          class: "plan-modal fs-sm"
        }, " ACA Mandate Related Reports ")
      ])
    ])
  ]))
}